import React from 'react'
import axios from 'axios'
import { useState, useEffect } from 'react'
import CategoryRow from './CategoryRow'
import AdminSidebar from './AdminSidebar'
import AdminNavbar from './AdminNavbar'
const SERVER_URL = process.env.REACT_APP_SERVER_URL


const AdminCategories = () => {
  const [modal, setModal] = useState(false)
  const [rerender, setRerender] = useState(0)
  const alert = (msg, type) => (
    <div className={`bg-${type} my-2 py-2 px-4 w-100`}>{msg}</div>
  );
  const [categories, setCategories] = useState({});
  useEffect(() => {
    axios.get(SERVER_URL+"/api/admin/all-category/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(localStorage.getItem("userTokenTime")).token,
        }
      }
    ).then((res) => {
      console.log(res.data.Categories);
      setCategories(res.data.Categories);
    });
  }, [modal, rerender]);


  const [fData, setFdata] = useState({
    cName: "",
    cDescription: "",
    cImage: "",
    cStatus: "Active",
    cType: "Men",
    success: false,
    error: false,
  });

  if (fData.error || fData.success) {
    setTimeout(() => {
      setFdata({ ...fData, success: false, error: false });
    }, 2000);
  }

  const deleteCategoryReq = (cId) => {
    axios.post(
      SERVER_URL+
      "/api/admin/delete-category",
      { cId: cId },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(localStorage.getItem("userTokenTime")).token,
        },
      }
    )
      .then((res) => {
        console.log(res.data);
        setRerender((prev) => prev + 1);
      }).catch((e) => {
        console.log(e);
      });
  };

  const formSubmitHandler = (e) => {
    e.preventDefault();
    if (!fData.cImage) {
      return setFdata({ ...fData, error: "Please upload a category image" });
    }
    console.log(fData);
    let formData = new FormData();
    formData.append("cImage", fData.cImage);
    formData.append("cName", fData.cName);
    formData.append("cDescription", fData.cDescription);
    formData.append("cStatus", fData.cStatus);
    formData.append("cType", fData.cType);
    if (localStorage.getItem("userTokenTime") != null) {
      axios
        .post(
          SERVER_URL+
          "/api/admin/add-category",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("userTokenTime")).token,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          if (!res.data.error) {
            setModal(false);
          }
          else {
            setFdata({ ...fData, success: false, error: res.data.error });
          }
        }).catch((e) => {
          console.log(e);
        });
    }
  };

  return (
    <div>
      <AdminNavbar />
      <div className='panel__container'>
        <AdminSidebar activeTab={2} />
        <div className={`${modal ? "" : "mhidden"} backdrop`}></div>
        <div
          className={`${modal ? "" : "mhidden"} addmodel cmodel`}
        >
          <div className="modaldiv relative space-y-4 overflow-y-auto px-4 py-4 md:px-8">
            <div className="modal__header">
              <span className="modal__heading">
                Add Category
              </span>
              {/* Close Modal */}
              <span
                style={{ background: "#303031" }}
                onClick={() => setModal(false)}
                className="modal-close-btn"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </span>
            </div>
            {fData.error ? alert(fData.error, "red") : ""}
            {fData.success ? alert(fData.success, "green") : ""}
            <form className="w-100" >
              <div className="form__input">
                <label htmlFor="name">Category Name</label>
                <input
                  onChange={(e) =>
                    setFdata({
                      ...fData,
                      success: false,
                      error: false,
                      cName: e.target.value,
                    })
                  }
                  value={fData.cName}
                  className="px-4 py-2 border focus:outline-none"
                  type="text"
                />
              </div>
              <div className="form__input">
                <label htmlFor="description">Category Description</label>
                <textarea
                  onChange={(e) =>
                    setFdata({
                      ...fData,
                      success: false,
                      error: false,
                      cDescription: e.target.value,
                    })
                  }
                  value={fData.cDescription}
                  className="px-4 py-2 border focus:outline-none"
                  name="description"
                  id="description"
                  cols={5}
                  rows={5}
                />
              </div>
              {/* Image Field & function */}
              <div className="form__input">
                <label htmlFor="name">Category Image</label>
                <input
                  accept=".jpg, .jpeg, .png, .webp, .avif"
                  onChange={(e) => {
                    setFdata({
                      ...fData,
                      success: false,
                      error: false,
                      cImage: e.target.files[0],
                    });
                  }}
                  className="px-4 py-2 border focus:outline-none"
                  type="file"
                  multiple="false"
                />
              </div>
              <div className="d-flex">
                <div className="form__input">
                  <label htmlFor="status">Category Status</label>
                  <select
                    name="status"
                    onChange={(e) =>
                      setFdata({
                        ...fData,
                        success: false,
                        error: false,
                        cStatus: e.target.value,
                      })
                    }
                    className="px-4 py-2 border focus:outline-none"
                    id="status"
                  >
                    <option name="status" value="Active">
                      Active
                    </option>
                    <option name="status" value="Disabled">
                      Disabled
                    </option>
                  </select>
                </div>
                <div className="form__input ml-2">
                  <label htmlFor="status">Category Type</label>
                  <select
                    name="status"
                    onChange={(e) =>
                      setFdata({
                        ...fData,
                        success: false,
                        error: false,
                        cType: e.target.value,
                      })
                    }
                    className="px-4 py-2 border focus:outline-none"
                    id="type"
                  >
                    <option name="type" value="Men">
                      Men
                    </option>
                    <option name="type" value="Women">
                      Women
                    </option>
                    <option name="type" value="Kids">
                      Kids
                    </option>
                  </select>
                </div>
              </div>
              <div className="create-btn-div">
                <button
                  style={{ background: "#303031" }}
                  type="submit"
                  className="create__btn"
                  onClick={formSubmitHandler}
                >
                  Create category
                </button>
              </div>
            </form>
          </div>
        </div>

        <div style={{ width: "87.5%", padding: "20px", marginLeft: "12.5%" }}>
          <div className='outer__container'>
            <div>
              <div>
                <div className="addcat__button"
                  onClick={() => setModal(true)}

                >
                  <svg className="w-6 h-6 text-gray-100 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd"></path></svg>
                  Add Category
                </div>
              </div>
            </div>
            <div className='inner__container2' style={{ padding: "1.5rem", marginTop: "1.5rem" }}>
              <div style={{ height: "10px" }}></div>

              <table className="border w-100 my-2">
                <thead>
                  <tr>
                    <th className="px-4 py-2 border">Category</th>
                    <th className="px-4 py-2 border">Description</th>
                    <th className="px-4 py-2 border">Image</th>
                    <th className="px-4 py-2 border">Type</th>
                    <th className="px-4 py-2 border">Status</th>
                    <th className="px-4 py-2 border">Created at</th>
                    <th className="px-4 py-2 border">Updated at</th>
                    <th className="px-4 py-2 border">Actions</th>
                  </tr>

                </thead>
                <tbody className='cat__row'>
                  {categories && categories.length > 0 ? (
                    categories.map((item, key) => {
                      return (
                        <CategoryRow
                          category={item}
                          deleteCat={(cId) => deleteCategoryReq(cId)}
                          key={key}
                        />
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="7"
                        className="text-xl text-center py-8"
                      >
                        No category found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="text-sm text-gray-600 mt-2" style={{ color: "gray", marginTop: "0.5rem", textAlign: "left" }}>
                Total {categories && categories.length} category found
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default AdminCategories